import { action } from '@reatom/framework'
import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { userAtom } from '@root/entities/auth'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { reatomRequest } from '@root/shared/lib'
import { showErrorCodeSnackbarAction } from '@root/shared/ui'
import { showSnackbarAction } from '@root/shared/ui-kit'

import {
  SecureStorageError,
  StorageAlreadyUnlockedError,
  toSharedErrorCode,
  WrongPasswordError,
} from '../secure-storage-error'

import { refreshSecureStorageStateAction } from './reatom-secure-storage-state'

import type { Redacted } from '@blade/std-lib'

export const unlockSecureStorageAction = action(
  async (ctx, { password }: { password: Redacted.Redacted }) => {
    const { secureStorageService } = ctx.get(dependenciesAtom)
    const currentUser = ctx.get(userAtom)

    if (!currentUser) {
      return Result.fail(SecureStorageError.fromUnknown())
    }

    const result = await ctx.schedule(() =>
      secureStorageService.unlock(currentUser.delugeId, password),
    )

    if (Result.isFailure(result)) {
      if (result.failure instanceof StorageAlreadyUnlockedError) {
        return Result.succeed({})
      }
      return Result.fail(SecureStorageError.fromUnknown(result.failure))
    }

    return Result.succeed({})
  },
  'unlockSecureStorageAction',
)

export const reatomUnlockSecureStorage = () => {
  const theAtom = reatomRequest({
    execAction: unlockSecureStorageAction,
    // eslint-disable-next-line @reatom/unit-naming-rule
    name: 'initializeSecureStorage',
    onResult: (ctx, result) => {
      if (Result.isFailure(result)) {
        if (result.failure instanceof WrongPasswordError) {
          showSnackbarAction(ctx, {
            text: i18next.t('auth.wrong-password'),
            intent: 'error',
          })
          return
        }
        showErrorCodeSnackbarAction(ctx, toSharedErrorCode(result.failure))
        return
      }
      refreshSecureStorageStateAction(ctx)
    },
  })

  return theAtom
}
